"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const AccountCircle_1 = __importDefault(require("@mui/icons-material/AccountCircle"));
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const Notifications_1 = __importDefault(require("@mui/icons-material/Notifications"));
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const globalVariables_1 = require("../../../common/globalVariables");
const useEventListener_1 = __importDefault(require("../../../common/helpers/Hooks/useEventListener"));
const BackButton_1 = __importDefault(require("./BackButton"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const services_1 = require("../../../common/services");
const helpers_1 = require("../../../common/helpers/helpers");
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const HeaderContainer = styled_components_1.default.div `
  width: 100%;
  border-bottom: solid 1px
    ${props => props.theme.palette.colorAppBar.main === '#fff' || props.theme.palette.colorAppBar.main === '#ffffff'
    ? '#E7E8E7'
    : props.theme.palette.colorAppBar.main};
  position: sticky;
  top: 0;
  background-color: ${props => props.theme.palette.colorAppBar.main};
  color: ${props => props.theme.palette.colorAppBar.contrastText};
  z-index: 1003;
  padding: 5px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;

  &.margin-bottom-0 {
    margin-bottom: 0;
  }

  &.isWeatherPage {
    background-color: transparent;
    border-bottom: none;

    svg {
      fill: #fff;
    }
  }

  .search-notification-wrapper {
    display: flex;
  }
`;
const HeaderWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;

  @media (min-width: 680px) {
    .icon-circle {
      margin-left: 0;
    }
  }

  .page-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.3;
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 25px;
  }

  &.isWeatherPage {
    color: #ffffff;
  }
`;
const VenueScreenHeader = styled_components_1.default.div `
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1005;
  padding: 0 16px;

  @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HEADER}px) {
    padding: 0;
  }

  box-shadow: none;

  transition: background 0.2s linear, box-shadow 0.2s linear;

  &.scrolled {
    background-color: ${props => props.theme.palette.colorAppBar.main};
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  }

  &.not-scrolled {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(224, 224, 224, 0) 100%);
  }

  .user-icon-wrapper {
    width: 0px;

    &.end {
      display: flex;
      justify-content: flex-end;
    }

    .notification-icon {
      margin-left: 8px;
    }
  }

  .content-header {
    max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    padding: 12px 0;

    .menu-dropdown {
      width: 300px;
    }
  }

  .icon-circle {
    padding: 0;
    height: 40px;
    width: 40px;
    background-color: ${props => props.theme.palette.colorAppBar.main};
    z-index: 1;

    @media (max-width: 380px) {
      height: 35px;
      width: 35px;
    }

    &:hover {
      opacity: 0.9;
    }

    svg {
      height: 24px;
    }
  }

  .logo-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;

    .logo,
    svg {
      height: 40px;
    }
  }

  @media (max-width: 399px) {
    .logo-wrapper {
      position: relative;
      left: -20px;
    }
  }
`;
const SimpleHeader = (props) => {
    const { location, navigations, history, baseUrl, appData, currentLocale, userData, directories, offers } = props;
    const [pageTitle, setPageTitle] = (0, react_1.useState)('');
    const [isScroll, setIsScroll] = (0, react_1.useState)(false);
    const [notificationData, setNotificationData] = (0, react_1.useState)(null);
    const fetchNotificationInfo = () => {
        services_1.apiService.getNotificationInfo(currentLocale, userData.token).then((data) => {
            const event = new CustomEvent('refetchNotifications');
            window.dispatchEvent(event);
            setNotificationData(data.info);
        });
    };
    const handleNotificationBadge = (event) => {
        const { type } = event.data;
        if (type === 'fetchNotificationBadge') {
            fetchNotificationInfo();
        }
    };
    (0, react_1.useEffect)(() => {
        // Sync other tabs
        const channel = new BroadcastChannel('notifications');
        channel.addEventListener('message', () => {
            if (document.hidden && userData.token) {
                fetchNotificationInfo();
            }
        });
        return () => {
            channel.close();
        };
    }, [userData.token]);
    (0, react_1.useEffect)(() => {
        if (userData.token) {
            fetchNotificationInfo();
        }
        window.addEventListener('fetchNotificationBadge', fetchNotificationInfo);
        // Trigger notification badge update when receiving a notification push
        if ('serviceWorker' in navigator && 'PushManager' in window && userData.token) {
            navigator.serviceWorker.addEventListener('message', handleNotificationBadge);
        }
        return () => {
            window.removeEventListener('fetchNotificationBadge', fetchNotificationInfo);
            if (navigator.serviceWorker) {
                navigator.serviceWorker.removeEventListener('message', handleNotificationBadge);
            }
        };
    }, [userData.token]);
    const flattenedDirectories = helpers_1.Helpers.flattenCollection(directories, true);
    const flattenedOffers = helpers_1.Helpers.flattenCollection(offers, true);
    const allPathname = window.location.pathname.split('/');
    const id = allPathname[allPathname.length - 1].split('-').slice(-1)[0];
    (0, react_1.useEffect)(() => {
        if (window.location.pathname.includes('/notifications/')) {
            return;
        }
        if (!window.location.pathname.includes('/folder/') &&
            !window.location.pathname.includes('/page/') &&
            !window.location.pathname.includes('/website/') &&
            !window.location.pathname.includes('/document/')) {
            return;
        }
        if (window.location.pathname.includes('/folder/')) {
            const targetDirectory = [...flattenedDirectories, ...flattenedOffers].find((directory) => {
                if (!directory.folder) {
                    return false;
                }
                return String(directory.folder.id) === id;
            });
            if (targetDirectory && targetDirectory.folder && targetDirectory.folder.title) {
                setPageTitle(targetDirectory.folder.title);
            }
        }
        if ((window.location.pathname.includes('/page/') ||
            window.location.pathname.includes('/directory/') ||
            window.location.pathname.includes('/website/')) &&
            !window.location.pathname.includes('/folder/')) {
            let pageParentDirectory = null;
            let enounteredDirectoryChild = false;
            [...flattenedDirectories, ...flattenedOffers].forEach((directory) => {
                if (enounteredDirectoryChild) {
                    return;
                }
                if (directory.folder) {
                    pageParentDirectory = directory;
                    return;
                }
                const type = Object.keys(directory)[0];
                if (directory[type] && String(directory[type].id) === id) {
                    enounteredDirectoryChild = true;
                }
            });
            if (pageParentDirectory && pageParentDirectory.folder && pageParentDirectory.folder.title) {
                setPageTitle(pageParentDirectory.folder.title);
            }
        }
    }, [directories, offers]);
    const onRouteChange = newRoute => {
        const path = newRoute.pathname.split('/').pop();
        const isDeeplink = location && location.state === 'deeplink';
        if (window.location.pathname.includes('/notifications')) {
            setPageTitle(i18n_js_1.default.t('notifications_header'));
            return '';
        }
        if (navigations.homePage) {
            // guest journey
            if (window.location.pathname.includes('/guest_journey')) {
                setPageTitle(i18n_js_1.default.t('api_guest_journey_my_reservations_title'));
                return '';
            }
            if (window.location.pathname.includes('/folder')) {
                const targetDirectory = [...flattenedDirectories, ...flattenedOffers].find(directory => {
                    if (!directory.folder) {
                        return false;
                    }
                    return String(directory.folder.id) === id;
                });
                if (targetDirectory && targetDirectory.folder && targetDirectory.folder.title) {
                    setPageTitle(targetDirectory.folder.title);
                }
            }
            if (isDeeplink) {
                setPageTitle('');
                return '';
            }
            navigations.homePage.map(item => {
                if (item.type === path) {
                    setPageTitle(item.title);
                    return '';
                }
                // the following if statement is for set a page title for Settings
                if (path === 'settings' && item.type === 'preferences') {
                    setPageTitle(item.title);
                    return '';
                }
                if (path === 'language' && item.type === 'preferences') {
                    setPageTitle(i18n_js_1.default.t('languages_label'));
                    return '';
                }
                return '';
            });
        }
        return '';
    };
    const handleSearchClick = () => {
        helpers_1.Helpers.openSearchModal(modalEnums_1.default.SEARCH, {});
    };
    const handleNotificationClick = () => {
        history.push({
            pathname: `${baseUrl}${baseUrl !== '/' ? '/' : ''}notifications`,
            search: location.search,
        });
    };
    const markAllAsRead = () => {
        const event = new CustomEvent('markAllAsRead');
        window.dispatchEvent(event);
    };
    const handleScroll = () => {
        if (window.scrollY > 35) {
            return setIsScroll(true);
        }
        return setIsScroll(false);
    };
    (0, useEventListener_1.default)('scroll', () => {
        handleScroll();
    });
    (0, react_1.useEffect)(() => {
        onRouteChange(location);
    }, [location, navigations === null || navigations === void 0 ? void 0 : navigations.homePage]);
    const goToSettingsPage = () => {
        history.push({
            pathname: `${baseUrl}${baseUrl !== '/' ? '/' : ''}settings`,
            search: location.search,
        });
    };
    // homescreen
    const isVenueStartScreen = location.pathname.split('/').length === 2;
    const logo = appData.theme.logoUrl;
    const isWeatherPage = location.pathname.includes('/weather');
    const pagesWithoutNotificationBtn = ['/weather', '/settings', '/notifications'];
    const isPageWithoutNotificationBtn = pagesWithoutNotificationBtn.some(page => location.pathname.includes(page));
    const showReadAllNotificationsButton = location.pathname.includes('/notifications') &&
        !(location.pathname.includes('/notifications/detail') && window.innerWidth < 1000);
    const pagesWithoutSearchIcon = [
        '/weather',
        '/settings',
        '/bookings',
        '/contact',
        '/conventions',
        '/notifications',
        '/chat',
    ];
    const isPageWithoutSearchIcon = pagesWithoutSearchIcon.some(page => location.pathname.includes(page));
    const isChatPage = location.pathname.includes('/chat');
    const hideBackButton = window.location.search.includes('hide_back_button=true');
    return (react_1.default.createElement(react_1.Fragment, null, isVenueStartScreen ? (react_1.default.createElement(VenueScreenHeader, { className: `venue-screen-header ${isScroll ? 'scrolled' : 'not-scrolled'}` },
        react_1.default.createElement(material_1.Box, { className: "content-header" },
            react_1.default.createElement(material_1.Box, { className: "user-icon-wrapper" },
                react_1.default.createElement(material_1.IconButton, { color: "colorAppBar", "aria-label": "account of current user", onClick: goToSettingsPage, className: "icon-circle" },
                    react_1.default.createElement(AccountCircle_1.default, { fontSize: "medium", color: "colorOnAppBar" }))),
            react_1.default.createElement("div", { className: "logo-wrapper" },
                react_1.default.createElement("img", { src: logo, alt: "Venue Logo", className: "logo" })),
            react_1.default.createElement(material_1.Box, { className: "user-icon-wrapper end" },
                react_1.default.createElement(material_1.IconButton, { edge: false, "aria-label": "search", className: "icon-circle", onClick: handleSearchClick, id: "aqa_navigation_search" },
                    react_1.default.createElement(Search_1.default, { fontSize: "medium", color: "colorOnAppBar" })),
                react_1.default.createElement(material_1.IconButton, { color: "inherit", edge: false, "aria-label": "search", className: "icon-circle notification-icon", onClick: handleNotificationClick, id: "aqa_navigation_notifications" },
                    react_1.default.createElement(material_1.Badge, { badgeContent: notificationData ? notificationData.badge : 0, max: 9, color: "error" },
                        react_1.default.createElement(Notifications_1.default, { fontSize: "medium", color: "colorOnAppBar" }))))))) : (react_1.default.createElement(HeaderContainer, { className: `${isWeatherPage ? 'isWeatherPage' : ''}` },
        react_1.default.createElement(HeaderWrapper, { maxWidthHeader: globalVariables_1.WEB_APP.MAX_WIDTH_HEADER, className: isWeatherPage ? 'isWeatherPage' : '' },
            !hideBackButton ? react_1.default.createElement(BackButton_1.default, null) : react_1.default.createElement("span", null),
            react_1.default.createElement("h4", { className: "page-title" }, pageTitle)),
        react_1.default.createElement(material_1.Box, { className: "search-notification-wrapper" },
            !isPageWithoutSearchIcon ? (react_1.default.createElement(material_1.IconButton, { color: "inherit", edge: false, "aria-label": "search", className: "icon-circle", onClick: handleSearchClick, id: "aqa_navigation_search" },
                react_1.default.createElement(Search_1.default, { fontSize: "medium", color: "colorOnAppBar" }))) : (react_1.default.createElement("span", null)),
            !isPageWithoutNotificationBtn || isChatPage ? (react_1.default.createElement(material_1.IconButton, { color: "inherit", edge: false, "aria-label": "search", className: "icon-circle", onClick: handleNotificationClick, id: "aqa_navigation_notifications" },
                react_1.default.createElement(material_1.Badge, { badgeContent: notificationData ? notificationData.badge : 0, max: 9, color: "error" },
                    react_1.default.createElement(Notifications_1.default, { fontSize: "medium", color: "colorOnAppBar" })))) : (react_1.default.createElement("span", null)),
            showReadAllNotificationsButton ? (react_1.default.createElement(material_1.IconButton, { color: "inherit", edge: false, "aria-label": "search", className: "icon-circle", onClick: markAllAsRead, id: "aqa_navigation_notifications_bulk", disabled: notificationData && notificationData.count === 0 },
                react_1.default.createElement(material_1.Badge, { badgeContent: notificationData ? notificationData.badge : 0, max: 9, color: "error" },
                    react_1.default.createElement(icons_material_1.Checklist, { fontSize: "medium", color: notificationData && notificationData.count === 0 ? 'disabled' : 'colorOnAppBar' })))) : (react_1.default.createElement("span", null)))))));
};
const mapStoreToProps = store => ({
    navigations: store.getValue('navigations'),
    baseUrl: store.getValue('baseUrl'),
    appData: store.getValue('appData'),
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    directories: store.getValue('directory'),
    offers: store.getValue('offers'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(SimpleHeader));
